/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProductionModeManual {
  None = 'None',
  ManualWorkingPlace = 'ManualWorkingPlace',
  Cutting = 'Cutting',
  Packing = 'Packing'
}
